<script lang="ts">
import {
  PhxsgIconProps as PhxsgCoreIconProps,
  PhxsgIcon as PhxsgCoreIcon,
} from '@sg-core/src/View/Components/Atoms/Icon';

export type PhxsgIconSize = 'sm' | 'md' | 'lg' | 'logo' | null;

export type PhxsgIconIds =
  | '360'
  | 'account'
  | 'audio'
  | 'calendar'
  | 'cart'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-left-lg'
  | 'chevron-right'
  | 'chevron-right-lg'
  | 'chevron-up'
  | 'clear'
  | 'close'
  | 'copyright'
  | 'edit'
  | 'facebook'
  | 'filters'
  | 'geoloc'
  | 'heart'
  | 'heart-full'
  | 'home'
  | 'info'
  | 'instagram'
  | 'line'
  | 'linkedin'
  | 'loader'
  | 'logo'
  | 'menu'
  | 'minus'
  | 'pause'
  | 'phone'
  | 'pin'
  | 'pin-full'
  | 'play'
  | 'plus'
  | 'search'
  | 'silhouette'
  | 'wechat'
  | 'wechat-outline'
  | 'weibo'
  | 'world'
  | 'youtube'
  | 'zoom-in'
  | 'zoom-out';

export type PhxsgIconProps = PhxsgCoreIconProps & { id: PhxsgIconIds; size?: PhxsgIconSize };
</script>

<script setup lang="ts">
withDefaults(defineProps<PhxsgIconProps>(), {
  size: null,
});
</script>

<template>
  <PhxsgCoreIcon v-bind="$props" />
</template>

<style src="./icon.css" />
